import React, { Fragment, useState, useEffect ,useRef} from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import Cookies from 'js-cookie';
import $ from 'jquery';
import "./hoteldetails.css";
import { useTranslation } from "react-i18next";
import Lightbox from 'react-image-lightbox';
import hotelimg from "../imagepreview.png"
import 'react-image-lightbox/style.css';

import "./hoteldetails.css";

const HotelOfferPage = () => {

  const { config } = require('../api/api');
  
  const [contacts, setContacts] = useState([{ email: "", countryCode: "", mobile: "" },]);
  const [isChecked, setIsChecked] = useState(false);
  const selectOpt1 = useRef(null);
 
  const [vendorKey, setVendorkey] = useState('');
  const [token, setToken] = useState(false);
 
  const[offerId,setOfferId]=useState();
  const[roomId,setRoomId]=useState([]);
  const[Id,setId]=useState();
  const[countrylist,setCountylist]=useState([]);
 
  const[priceInfo,setPriceInfo]=useState([]);
 
  const [allInformation,setAllInformation]=useState(null);
  const [imgDetails,setImgDetails]=useState(null);
  const [roomDetails,setRoomDetails]=useState([]);
  const[hotelDetails,setHotelDetails]=useState(null);
  const [loading ,setLoading ]=useState(true);
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  const [timeExpired, setTimeExpired] = useState(false);
  const [guestCount,setGuestCount]=useState("");
  const [nightsCount,setNightsCount]=useState("");
  const [countryCodes,setCountryCodes]=useState(["","",""]);
  const [userData, setUserData] = useState();

  const selectRefs=[selectOpt1,useRef(null),useRef(null)];
  const [roomsData,setRoomsData]=useState(null);
  const [cancellationPolicyBox,setCancellationPolicyBox]=useState(false);
  const [formSubmit,setFormSubmit]=useState(false);

  
const mobileref = useRef([]);
const emailref = useRef([]);
const countryCoderef = useRef([]);
const firstnameref = useRef([]);
const lastnameref = useRef([]);
 const [isOpen, setIsOpen] = useState(false);
  const [roomImage, setRoomImage] = useState({});
  const [currentHotelId, setCurrentHotelId] = useState(null);
  const [photoIndex, setPhotoIndex] = useState(0);



  const base_url = config.baseURL;
  



 useEffect(() => {

  const storedUserString = Cookies.get('userData');
          if (storedUserString !== undefined) {
            const user_data = JSON.parse(storedUserString);
          
            setUserData(user_data);

            
            
          } else {
          //   alert('Login Session Expired');
          //   window.location.href = '/';
          }

    const postvData = { organization_name: "Superjet" };    

    if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {

      fetch(base_url + '/create_organization', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postvData),
      })
        .then(response => response.json())
        .then(data => {
          setVendorkey(data.result[0].vendor_key);
          
        })
        .catch(error => {
          console.error('Error posting data:', error);
        });


    }
  }, [vendorKey]);



  useEffect(()=>{
  
    const storedData = Cookies.get('auth_key');
    if (storedData !== undefined) {
      const storedtoken = JSON.parse(storedData);
      setToken(storedtoken);
    
     
    }
    else {
      // alert("token expired");
      // window.location.href='/';
    }
  },[]);
  useEffect(()=>{
    for(let i=0; i<contacts.length && i<3; i++){
      handleSelect(i);
    }
  },[contacts])


  useEffect(()=>{
    setContacts(prev => prev.map((contact, i) => 
      countryCodes[i] ? {...contact, countryCode: countryCodes[i]} : contact
    ));
  },[countryCodes])


  const handleSelect=(index)=>{
    const ref = selectRefs[index].current;
    $(ref).select2();
    $(ref).next(".select2-container").find(".select2-selection--single").addClass("hotel");
    $(ref).on('select2:select', (e) => {
      const select_id = e.params.data.id;
      if(select_id){
        $(ref).next(".select2-container").find(".select2-selection--single.hotel").removeClass("error");
        setCountryCodes(prev => prev.map((code, i) => i === index ? select_id : code));
      }
    });
    return () => $(ref).select2('destroy');
  };

 
          
useEffect(()=>{
  const getContacts=sessionStorage.getItem("hotelContacts");
  if(getContacts){
    const parse_contacts=JSON.parse(getContacts);
    setContacts(parse_contacts);
  }
},[])

 const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';


  const { t } = useTranslation();
  

  const addRow = () => {

    if (contacts.length < 3) {

      setContacts([...contacts, { email: "", countryCode: "", mobile: "" }]);
    }
  };
  const removeRow = (index) => {
    const updatedContacts = contacts.filter((_, i) => i !== index);
    setContacts(updatedContacts);
  };
  const handlecheckbox = (event) => {
    setIsChecked(event.target.checked);
  }
   useEffect(() => {
         if (timeLeft <= 0){
           setTimeExpired(true);
           return;
         }
         const getTimer =sessionStorage.getItem("offerTimer");
         if(getTimer){
           setTimeLeft(getTimer);
         }
          
         const timer = setInterval(() => {
           setTimeLeft((prevTime) =>{
             const updated =prevTime - 1;
             sessionStorage.setItem('offerTimer', updated);
         return updated;
       });
         }, 1000);
         return () => clearInterval(timer);
       }, [timeLeft]);
     
       const handleRestart = () => {
         sessionStorage.setItem("offerTimer", 15 * 60);
         window.location.href="/hotel-search" 
       };


  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };


 


const handlechange=(index,e)=>{
   const {name,value}=e.target;
   setContacts(prev => prev.map((contact, i) =>
    i === index ? { ...contact, [name]: value } : contact
  ));
}



  
  const handleSubmit = async (event) => {
    debugger
    
event.preventDefault();

setFormSubmit(true);
// roomsData[i].guests[j]?.lastname===""
var valid =true;

let firstEmptyField = null;

for(let i=0;i<roomsData.length;i++){
  for(let j=0;j<roomsData[i].guests.length;j++){

    if(roomsData[i].guests[j]?.firstname===""|| roomsData[i].guests[j]?.firstname===null ||roomsData[i].guests[j]?.firstname===undefined || roomsData[i].guests[j]?.firstname.length<2){
      if(!firstEmptyField) firstEmptyField = () => firstnameref.current[i]?.[j]?.focus();
     valid=false;
    }
    if(roomsData[i].guests[j]?.lastname===""|| roomsData[i].guests[j]?.lastname===null ||roomsData[i].guests[j]?.lastname===undefined || roomsData[i].guests[j]?.lastname.length<2 ){
      if(!firstEmptyField) firstEmptyField = () => lastnameref.current[i]?.[j]?.focus();
      valid=false;
    }
  }
}

for(let i=0;i<contacts.length;i++){
  if( contacts[i]?.email===""|| contacts[i]?.email===null || contacts[i]?.email===undefined){
    if(!firstEmptyField) firstEmptyField = () => emailref.current[i]?.focus();
    valid=false
  }else {
  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contacts[i].email);
  if (!isValidEmail) {
    if(!firstEmptyField) firstEmptyField = () => emailref.current[i]?.focus();
    valid = false;
  }
}
  if( contacts[i]?.countryCode==="" ||  contacts[i]?.countryCode===null || contacts[i]?.countryCode===undefined ){
    const selectRef = selectRefs[i]?.current;
    if(selectRef){
      $(selectRef).next(".select2-container").find(".select2-selection--single.hotel").addClass("error");
      if(!firstEmptyField) {
        firstEmptyField = () =>{
          $(selectRef).select2("open");
          setTimeout(() => document.querySelector(".select2-search__field")?.focus(), 0);
        }
      }
    }
    valid=false;
  }
  if( contacts[i]?.mobile==="" ||  contacts[i]?.mobile===null || contacts[i]?.mobile===undefined ){
     if(!firstEmptyField) firstEmptyField = () => mobileref.current[i]?.focus();
     valid=false;
  }
}

if(!valid && firstEmptyField){
  firstEmptyField();
}

if(valid){

  sessionStorage.setItem("hotelContacts",JSON.stringify(contacts));
  sessionStorage.setItem("roomInfo",roomDetails[0].class);

const list_email=[];

  for(let i=0;i<contacts.length;i++){
    list_email[i]=contacts[i].email;
  }
  const list_phone=[];
  for(let j=0;j<contacts.length;j++){
    const split_country =contacts[j]?.countryCode.split(" ");
    const country_code=split_country[split_country.length-1];
    list_phone[j]=country_code+" "+contacts[j].mobile;
  }

    var details={
      etmtoken:token,
      order_payload:{
      emails: list_email ,
      h_offer_id: Id,
      payment_method: "deposit",
      payment_method_psp_id: "",
      phones:list_phone,
      rooms: JSON.stringify(roomsData)
  }
}


const search_data=sessionStorage.getItem("hotelSearchData");
const destination=search_data?search_data?.searchdata?.poi_name:"";
  sessionStorage.setItem("hotelpayment", JSON.stringify(details));
  const hotel_card_data={
    ...details,
    additional_data:{
    checkin_date:allInformation?.stay_dates?.from,
    checkout_date:allInformation?.stay_dates?.to,
    hotel_name:allInformation?.hotel?.name,
    hotel_address:allInformation?.hotel?.address,
    hotel_city:allInformation?.hotel?.city_name ||destination|| "",
    total_guest_count:guestCount,
    nights_quantity:nightsCount,
    rooms_count:roomDetails?.length>0?roomDetails.length:"0",
    room_id:roomId.join(", "),
    price:priceInfo?.USD?.total,
    currency:"USD",
    user_type:null,
    token:null,
  }}

  if(userData && userData.access_token){
        if(userData.type==="staff"){
          hotel_card_data.additional_data["user_type"]="staff";
        }
        else if(userData.agency_name){
         hotel_card_data.additional_data["user_type"]="agent";
        }
        else if(userData.first_name){
         hotel_card_data.additional_data["user_type"]="user";
        }
         hotel_card_data.additional_data["token"]=userData.access_token;
      }
  try{
  
  const response=await fetch(base_url+"/create_hotel_card",{
    method:"POST",
    headers:{
      "Authorization":"Bearer "+vendorKey,
      "Content-Type":"application/json"
    },
    body:JSON.stringify(hotel_card_data)
  });
  if(!response.ok){
  console.log("ERR at creating hotel card status: "+response.status);
  }
  else{
   const data=await response.json();
   if(data.message==="success"){ 
      const id = btoa(data.result[0].id);
      const key= "uA$te4F91PksQ2@E#yGmH8zL&Xd57T";
      const final_key=id.slice(0, 2) + key + id.slice(2)
      sessionStorage.setItem("hotelCardId",final_key);
      window.location.href="/hotel-payment";
   }
  }
}catch(err){
  console.log(err);
}
}

};


  useEffect(() => {
    
      const storedData = sessionStorage.getItem("Offer_id");
      if (storedData) {
       
          setOfferId(storedData);
                }
            }, []);
        
    
      const StarRating = (rating, totalStars = 5 ) => {
     
        const filledStars = Math.round(rating);
        const emptyStars = totalStars - filledStars;
        const filledArr=new Array(filledStars);
        filledArr.fill("fullStar");
        const emptyArr=new Array(emptyStars);
        emptyArr.fill("emptyStar");
        return (
            <div className="star-rating" style={{ display: 'flex', padding: '0' }}>
                {filledArr?.map((_, index) => (
                    <span
                        key={`filled-${index}`}
                        //   onClick={() => handleStarClick(index)}
                        style={{ color: 'gold', cursor: 'pointer' }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                            <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                        </svg>
                    </span>
                ))}
                {emptyArr?.map((_, index) => (
                    <span
                        key={`empty-${index}`}
                        //   onClick={() => handleStarClick(filledStars + index)}
                        style={{ color: 'gray', cursor: 'pointer' }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star" viewBox="0 0 16 16">
                            <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" />
                        </svg>
                    </span>
                ))}
            </div>
        );

    }  
  
    

    const handleBackBtn=(e)=>{
      e.preventDefault();
      window.location.href="/hotel-search";
    }
   useEffect(()=>{

          const getpricing=async()=>{
           
          const offer_id=sessionStorage.getItem("Offer_id");
          const hotel_offer_data={
              etmtoken:token,
              offer_id:offer_id
              }
           try {
              const response =await fetch(`${base_url}/hotel_pricing`, {
                 method: "POST",
                 headers: {
                   "Authorization": "Bearer "+ vendorKey,
                   "Content-Type": "application/json"
                 },
                 body: JSON.stringify(hotel_offer_data)
               });
               if (!response.ok) {
                 console.log("http response status : ", response.status)
               }
               else {
                 const data = await  response.json();
                 if(data.message==="success"){
                 
                 setPriceInfo(data.result.price_per_currency);
                 
                 setImgDetails(data.result.image);
                 const {rooms,...filter}=data.result;
                 setAllInformation(filter);
                 setRoomDetails(rooms);
                 setHotelDetails(data.result.hotel);
                 setId(data.result.id);
                 setRoomId(data.result.rooms.map((r)=>(r.id)));
                 
                 
data.result.rooms.forEach((room) => {
  setRoomImage((prev) => ({
    ...prev,
    [room.id]: room.images
  }));
});
                 //Guest Count
                var guest_count=0;
                 for(let i=0;i<rooms.length;i++){
                   const adult_qty= rooms[i].adult_qty;
                   const child_qty=rooms[i].children.length;
                   guest_count+=adult_qty+child_qty;
                 }
                 setGuestCount(guest_count);

                // nights Count
                const checkin_date=data.result.stay_dates?.from;
              
                const checkout_date=data.result.stay_dates?.to;

                const diff_ms=Math.abs(new Date(checkout_date)-new Date(checkin_date));
                const days_diff=Math.ceil(diff_ms/( 1000 * 60 * 60 * 24))
                 setNightsCount(days_diff);


                 //Dynamically storing form data setup Ex : firstName ,lastName
                
                 //first storing room_id 
                //  [{room_id:87484}{room_id:49449}]
                const update_room = rooms.map((r) => ({ room_id: r.id }));

                for(let i=0;i<rooms.length;i++){
                 if(rooms[i].id){
                  const room_id=rooms[i].id;
                  const adult_qty= rooms[i].adult_qty;
                  const child_qty=rooms[i].children.length;

                 const adult_arr= Array(adult_qty).fill( {
                     "title":"Mr",
                      "firstname": "",
                      "firstname_failed": false,
                      "gender": "",
                      "gender_failed": false,
                      "is_owner": false,
                      "lastname": "",
                      "lastname_failed": false,
                      "type": "ADT"
                    });
                    adult_arr[0].is_owner=true;
                    let child_arr=[];
                    if(child_qty>0){
                    for(let c=0;c<child_qty;c++){
                    child_arr.push({
                       "age": rooms[i].children[c].age,
                       "age_failed": false,
                       "birthDate_failed": false,
                       "firstname": "",
                       "firstname_failed": false,
                       "id": rooms[i].children[c].id,
                       "lastname": "",
                       "lastname_failed": false,
                       "room_id": room_id,
                       "title": "Mr",
                       "type": "CHD"
                     });
                    }
                  }
                      
                      update_room.forEach((obj) => {
                        var guest_arr=[...adult_arr,...child_arr];
                        if (obj.room_id === room_id ) {
                          obj.guests = guest_arr;
                        }
                      });
                 }
                }
                setRoomsData(update_room);
                const hotel= sessionStorage.getItem("hotelpayment");
                if (hotel!==null && hotel!==undefined && hotel!=="") {
                  const parseData=hotel?JSON.parse(hotel):null;
                 
                    // setFname(parseData?.order_payload.rooms?JSON.parse(parseData?.order_payload.rooms)[0]?.guests[0]?.firstname:""); 
                    //  setLname(parseData?.order_payload.rooms?JSON.parse(parseData?.order_payload.rooms)[0]?.guests[0]?.lastname:"")
                    if(parseData){
                    const guest_info=JSON.parse(parseData?.order_payload?.rooms);
                     setRoomsData(guest_info);
                    }
                          }
                // next room_id based create  guest array 

                 }
               }
             }
             catch (err) {
               console.log("Hotel Show Offer API Err : ", err);
               setLoading(false);
                  }
                  setLoading(false);
                }
              if(vendorKey && token){
                getpricing()
              }
                },[vendorKey,token])  

                const handleOpenImageViewer = (offerId) => {
debugger
  setCurrentHotelId(offerId);
  setPhotoIndex(0); // reset to first image
  setIsOpen(true);
};


                
                useEffect(() => {
                
                  if(vendorKey!=='' && vendorKey!==null && countrylist.length===0)
                  {
              
                    var vkData = {vendor_key: vendorKey};
              
                    fetch(base_url+'/country', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify(vkData),
                    })
                        .then(response => response.json())
                        .then(data => {
                          
                          setCountylist(data.result);
                        })
                        .catch(error => {
                          console.error('Error fetching countries:', error);
                        });

                 
                    
                    
              
                  }
              
                }, [vendorKey]);

                const handleClose=()=>{
                  setCancellationPolicyBox(false);
                }


                const guestHandleChange = (e, room_index, room_id, type, guest_index) => {
            
                  const { name, value } = e.target;
                
                  // Clone roomsData to avoid mutating state directly (if using useState)
                  const updatedRooms = [...roomsData];
                
                  // Update the specific guest property
                  updatedRooms[room_index].guests[guest_index] = {
                    ...updatedRooms[room_index].guests[guest_index],
                    [name]: value,
                  };
                
                  // Then set state if you're using useState
                  setRoomsData(updatedRooms);
                
                 
                };
                
     
      const handleCancellationBox=()=>{
        setCancellationPolicyBox(true);
      }


     
  return (
    <Fragment>
      <div className="header_section1">
        <Navbar />
        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{lnstr==='en'?'E-Hotel Booking':"حجز الفنادق الإلكتروني"}</h3>
          </div>
        </div>
      </div>
      <div>
      <div className="container">
        <div className="row py-4 justify-content-center  mobile_reverse_direction">
       

          
          {/* {details.map((item, index) => ( */}
          
          <div className="col-md-8">
            <div className="card p-3 shadow"
              style={{
                //   width: '250px',
                //   height: '160px',
                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
                Width: "100%"
              }}>
              <h2 className="card-title p-0" >{t("Traveler")} {t("Information")}</h2>
              <span className="p-0">{t("All")} {t('data')} {t("must")} {t('be')} {t("indicated")} {t('in')} {t("latin")} {t("letters")}</span>
            </div>

            <div className="card p-3 shadow"
              style={{
                //   width: '250px',
                //   height: '160px',

                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
              }}>
              {roomDetails.length>0?roomDetails.map((roomobj,i)=>(
                <>
                <div className="d-flex">
                <div style={{ backgroundColor: "#eee", height: "80px", width: "40px", border: "0px solid" }}>
                  <h1 className="text-center p-2" style={{ fontSize: "30px" }}>{i+1}</h1></div>
                <div style={{
                  height: "80px",
                  width: "130px",
                  marginLeft: "10px"
                }}
                >

              <div style={{position:"relative",cursor:"pointer",height:"100%",width:"100%"}} 
                               onClick={()=>{
                                debugger
                                if(roomobj.images.length>0){
                                handleOpenImageViewer(roomobj.id)
                                }}
                                }>
                               
              <img
                src={roomobj.images.length>0?roomobj.images[0].url :imgDetails?.url }
                alt={""}
                style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                className="hotel-img"
                // className="hotel-room-mobile"
              />


            
                  {/* <img style={{width:"100%",height:"100%"}} src={imgDetails?.url} alt=""></img> */}
                
                 {roomobj.images.length>0 && <div
                                style={{
                                  position: 'absolute',
                                  bottom: '5px',
                                  left: '5px',
                                  backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                  color: 'white',
                                  padding: '2px 6px',
                                  fontSize: '12px',
                                  borderRadius: '3px',
                                }}
                              >
                                <span><img src={hotelimg} alt="image_icon" width="13" height="10" style={{ filter: 'invert(1)' }}/></span>
                                +{roomobj.images.length}
                              </div>
                              }
                </div>
                </div>
                <div className="d-block ml-2">
                  <h3 class="fw-bold p-0">{roomobj?.class}</h3>
                  <span class="text-muted">{roomobj?.description}</span>
                </div>
              </div>
             
              <div>
              <hr/>
           

            { [roomsData[i]]?.map((guests)=>(
                   guests.guests.map((gue,j)=>{
                    if(gue.type==="ADT"){
                    return(
                    <>
              <div className="d-flex mt-4">
                  

                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
                    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                  </svg>
                  <h5 className="ml-2">{t("Guest")} {j+1} {`${j==0?" ("+t("Owner")+")":""}`} </h5>
                </div>
                <div className='row mb-3'>

<div className='col-md-4'>

  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    <span>{t("First")} {t("Name")} <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
  </label>
  <input
    type='text'
     className={`form-control ${
    formSubmit && !roomsData[i].guests[j]?.firstname ? "is-invalid" : ""
  }`}
    value={roomsData[i].guests[j]?.firstname}
    name='firstname'
    placeholder={`${t("Enter")} ${t("name")}`}
    style={{border:`1px solid ${formSubmit && (roomsData[i].guests[j]?.firstname===""|| roomsData[i].guests[j]?.firstname===null || roomsData[i].guests[j]?.firstname===undefined || roomsData[i].guests[j]?.firstname.length<2)?"red" :"#ced4da"}`}}
    onChange={(e)=>guestHandleChange(e,i,roomsData[i].room_id,"ADT",j)}
    ref={(el) => {
      if (!firstnameref.current[i]) firstnameref.current[i] = [];
      firstnameref.current[i][j] = el;
    }}
    onInput={(e) => {
      e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
    }} 
    // onInput={(e) => {
    //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
    // }}

    />
    </div>

<div className='col-md-4'>
  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    <span>
      {t("Last")} {t("Name")}<span style={{ color: "red" }}>*</span>
    </span>
  </label>
  <input
    type='text'
     className={`form-control ${
    formSubmit && !roomsData[i].guests[j]?.lastname ? "is-invalid" : ""
  }`}
    name='lastname'
    // style={{border:`1px solid ${formSubmit && (roomsData[i].guests[j]?.lastname===""|| roomsData[i].guests[j]?.lastname===null || roomsData[i].guests[j]?.lastname===undefined || roomsData[i].guests[j]?.lastname.length<2)?"red" :"#ced4da"}`}}
    value={roomsData[i].guests[j]?.lastname}
     placeholder={`${t("Enter")} ${t("lastname")}`}
     onChange={(e)=>guestHandleChange(e,i,roomsData[i].room_id,"ADT",j)}
     ref={(el) => {
       if (!lastnameref.current[i]) lastnameref.current[i] = [];
       lastnameref.current[i][j] = el;
     }}
     onInput={(e) => {
      e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
    }} 
  />

</div> 
</div>
</>
                    )}
                    else if(gue.type==="CHD"){
                      return(
                        <>
              <div className="d-flex mt-4">
                  

                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
                    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                  </svg>
                  <h5 className="ml-2">Guest {j+1} (Child)</h5>
                </div>
                <div className='row mb-3'>

<div className='col-md-4'>

  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    <span>{t("First")} {t("Name")} <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
  </label>
  <input
    type='text'
      className={`form-control ${
    formSubmit && !roomsData[i].guests[j]?.firstname ? "is-invalid" : ""
  }`}
    value={roomsData[i].guests[j]?.firstname}
    // style={{border:`1px solid ${formSubmit && (roomsData[i].guests[j]?.firstname===""|| roomsData[i].guests[j]?.firstname===null || roomsData[i].guests[j]?.firstname===undefined)?"red" :"#ced4da"}`}}
    name='firstname'
    placeholder="Enter name"
    onChange={(e)=>guestHandleChange(e,i,roomsData[i].room_id,"CHD",j)}
    ref={(el) => {
      if (!firstnameref.current[i]) firstnameref.current[i] = [];
      firstnameref.current[i][j] = el;
    }}
    onInput={(e) => {
      e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
    }} 
    />
    </div>

<div className='col-md-4'>
  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    <span>
      {t("Last")} {t("Name")} <span style={{ color: "red" }}>*</span>
    </span>
  </label>
  <input
    type='text'
    className={`form-control ${
    formSubmit && !roomsData[i].guests[j]?.lastname ? "is-invalid" : ""
  }`}
    name='lastname'
    value={roomsData[i].guests[j]?.lastname}
    // style={{border:`1px solid ${formSubmit && (roomsData[i].guests[j]?.lastname===""|| roomsData[i].guests[j]?.lastname===null || roomsData[i].guests[j]?.lastname===undefined)?"red" :"#ced4da"}`}}
     placeholder="Enter lastname"
     onChange={(e)=>guestHandleChange(e,i,roomsData[i].room_id,"CHD",j)}
     ref={(el) => {
       if (!lastnameref.current[i]) lastnameref.current[i] = [];
       lastnameref.current[i][j] = el;
     }}
     onInput={(e) => {
      e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
    }} 
  />

</div> 
<div className='col-md-4'>
  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    <span>
    {t("Age")} <span style={{ color: "red" }}>*</span>
    </span>
  </label>
  <input
    type='number'
    name='age'
    disabled
    value={roomsData[i].guests[j]?.age?roomsData[i].guests[j]?.age:""}
  
    // onInput={(e) => {
    //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
    // }}
  />

</div> 
</div>
</>
                      )
                    }
             } )))}
                 
             
             
           
              
              </div>
              <br/>
              </>
              )):<></>}
              

            
                </div>
              <div className="card p-3 shadow mt-4"
              style={{
                //   width: '250px',
                //   height: '160px',
                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
                Width: "100%"
              }}>
              <h2 className="card-title p-0" >{t("Buyer")} {t("billing")} {t("info")}</h2>
            </div>
            <div className="card p-3 shadow"
              style={{
                //   width: '250px',
                //   height: '160px',
                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
              }}>
              {contacts.map((contact, index) => (
                <div key={index}>
                  <div className="d-flex align-items-center justify-content-end">
                    {contacts.length > 1 && (
                      <button
                        className="border-0 bg-transparent p-0 ms-2"
                        onClick={() => removeRow(index)}
                        style={{ cursor: "pointer" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" lass="bi bi-x" viewBox="0 0 16 16">
                          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                        </svg>
                      </button>
                    )}
                  </div>

                  <div className='row mb-3'>
                    <div className='col-md-4 ' >
                      <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>{t("Email ID")}<span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                      </label>
                      <input
                        type='email'
                         className={`form-control ${
    formSubmit && !contacts[index]?.email ? "is-invalid" : ""
  }`}
                        value={contacts[index]?.email}
                        name='email'
                         placeholder={`${t("Enter")} ${t("Email")}`}
                        onChange={(e)=>handlechange(index,e)}
                        ref={(el) => (emailref.current[index] = el)}
                        // style={{border:`1px solid ${formSubmit && (contacts[index]?.email===""|| contacts[index]?.email===null || contacts[index]?.email===undefined)?"red" :"#ced4da"}`}}
                        // onInput={(e) => {
                        //   e.target.value = e.target.value.replace( /^[^\s@]+@[^\s@]+\.[^\s@]+$/g, '');
                        // }}
                        onInput={(e) => {
                          const value = e.target.value;
                          e.target.value = value.replace(/[^a-zA-Z0-9@._-]/g, '');
                        }}
                        />

                    </div>

                    <div className='col-12 col-md-4'>
                      <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>
                          {t("Country's")} {t("phone")} {t("code")} <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </span>
                      </label>


                      
                      <select
                        // type='number'
                        className='form-control hotel-select'
                      name='number'
                       ref={selectRefs[index]}
                       value={contacts[index]?.countryCode}
                      >
                     <option value={''} disabled>{t("Select")} {t("country")} {t("code")}</option>
                    {countrylist?.map((item)=>(
                       <option key={item.id} value={item.code}>{item.country} {item.country_code}</option>

                    ))}
                    </select>

                    </div>

                    <div className='col-md-4'>
                      <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>
                          {t("Mobile")} {t("Number")} <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                        </span>
                      </label>
                      <input
                        type='text'
                        className={`form-control ${
    formSubmit && !contacts[index]?.mobile ? "is-invalid" : ""
  }`}
                        name='mobile'
                         placeholder={`${t("Enter")} ${t("mobile")} ${t("number")}`}
                        value={contacts[index]?.mobile}
                        //  style={{border:`1px solid ${formSubmit && (contacts[index]?.mobile===""|| contacts[index]?.mobile===null || contacts[index]?.mobile===undefined)?"red" :"#ced4da"}`}}
                        onChange={(e)=>handlechange(index,e)}
                        ref={(el) => (mobileref.current[index] = el)}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/\D/g, ''); // removes non-digit characters
                        }}
                      />
                      </div>
                  </div>
                </div>
              ))}

              <div className="col-md-1 text-end">
                <p className="text-danger" size={20} style={{ cursor: "pointer" }}  ></p>
              </div>
              <div className="d-flex justify-content-end">
                {contacts.length < 3 && (<button className="btn-primary rounded-pill text-white my-3 py-1 " onClick={addRow}>
                  + {t("Add")} {t("line")}
                </button>
                )}

              </div>
              {/* <div>
                <h3>Detailed Price</h3>
                <table className="table table-bordered mt-3">
                  <thead style={{ background: "#f4f6fb" }}>
                    <tr>
                      <th rowSpan={2}>Number</th>
                      <th rowSpan={2}>Net price </th>
                      <th rowSpan={2}>Markup</th>
                      <th colSpan={2} style={{ textAlign: "center" }}>Discount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Standard Single Room</td>
                      <td>48.08 $</td>
                      <td>
                        <strong>Own:</strong> <p>$0.92</p>
                        <strong>Total:</strong><p>${priceInfo?.USD?.total}</p>
                      </td>
                      <td>
                        <strong>Own:</strong> <p>$0.92</p>
                      </td>
                      </tr>
                      </tbody>
                   </table>
                  </div> */}
                  <div>
                <h3>{t("Price")} {t("Details")}</h3>
                <table className="table table-bordered mt-3">
                  <thead style={{ background: "#f4f6fb" }}>
                    <tr>
                      <th>{t("Room")}</th>
                     
                    </tr>
                  </thead>
                  <tbody>
                  {roomDetails.length>0?roomDetails.map((roomData,room_i)=>(
                    <tr key={room_i}>
                      <td>{roomData?.class}</td>
                      </tr>
                  )):<></>}
                   
                      </tbody>
                   </table>
                  </div>
                <div className="d-flex justify-content-end">
                <h4>{t("Total")} {priceInfo?.USD?.total+".00"} {t("dollars")}</h4>
                </div>
                </div>

            <div className="card p-3 shadow mt-4"
              style={{
                //   width: '250px',
                //   height: '160px',
                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
                Width: "100%"
              }}>
              <h2 className="card-title p-0">{t("Payments")} {t("types")}</h2>
              <div className="">
              <table className="table table-bordered mt-3">
                  <thead style={{ background: "#f4f6fb" }}>
                  <tr>
  <th>
    <input type="radio" id="deposit" name="transactionType" style={{position:"relative",top:"2px"}} checked/>
    &nbsp;&nbsp;<label for="deposit">{t("Deposit")}</label>
  </th>
</tr>

                    </thead>
                    </table>
             
              </div>
            </div>
             
            <div className="card p-3 shadow "
              style={{
                //   width: '250px',
                //   height: '160px',
                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
                Width: "100%"
              }}>

              <p style={{display:"flex"}}><input type="checkbox" onChange={handlecheckbox} checked={isChecked} name="note" />
                &nbsp;{t("I")} {t("agree")} {t("with")}<div style={{color:"blue",cursor:"pointer"}} onClick={handleCancellationBox}>&nbsp;{t("Booking")} {t("cancellation")} {t("policy")}</div>
              </p>
              <div className="d-flex justify-content-between">
                <button className="btn-primary rounded-pill text-white my-3 py-1 "  onClick={handleBackBtn}>
                  {t("Back")} {t("to")} {t("search")}
                </button>
                <button className="btn-primary rounded-pill text-white my-3 py-1 "
                onClick={(e)=>{handleSubmit(e)}}
                //  style={{ backgroundColor: isChecked ? 'blue' : "grey", borderColor: '#1D3561' }}
                disabled={!isChecked}
                style={{opacity:isChecked?"1":"0.75",cursor: isChecked ? "pointer" : "not-allowed"}}
                >
                  {t("Further")}
                </button>
              </div>
            </div>
            </div>
          <div className="col-md-4">
            <div className="card p-3 shadow"
              style={{
                //   width: '250px',
                //   height: '160px',
                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
                Width: "100%"
              }}>
              <h2 className="card-title p-0" >{t("Booking")} {t("details")}</h2>
              </div>

            <div className="card p-3 shadow">
              <div className="d-flex flex-column" >
                <h3 class="fw-bold p-0">{hotelDetails?.name}</h3>
                
                {hotelDetails!==null?
                <>
                 {StarRating(hotelDetails?.stars,5)}
                 </>:""}
              </div>
              <p>{hotelDetails?.address}</p>
              <div style={{
                height: "150px",
                width: "100%",
                overflow: "hidden",
                 }}>
                <img src={imgDetails?.url} class="w-100 h-20 object-fit-cover" alt=""></img>
              </div>
              <table class="table table-borderless">
                <tbody>
                  <tr>
                    <th >{t("Check-in")}</th>
                    <td>{allInformation!==null?allInformation?.stay_dates?.from:""}</td>
                  </tr>
                  <tr>
                    <th >{t("Check-out")}</th>
                    <td>{allInformation!==null?allInformation?.stay_dates?.to:""}</td>
                  </tr>
                  <tr>
                    <th scope="row">{t("Nights")}</th>
                    <td>{nightsCount}</td>
                  </tr>
                  <tr>
                    <th scope="row">{t("Guests")}</th>
                    <td>{guestCount}</td>
                  </tr>
                  <tr>
                    <th scope="row">{t("Rooms")}</th>
                    <td>{roomDetails?.length>0?roomDetails.length:"0"}</td>
                  </tr>
                </tbody>
              </table>
              <div>
                <h3>{t("Order")} {t("cost")} : {priceInfo?.USD?.total}.00 {t("dollars")}</h3>
              </div>
              </div>

            <div className="card p-3 shadow"
              style={{
                //   width: '250px',
                //   height: '160px',
                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
                Width: "100%"
              }}>
              <div className="d-flex">
                <h2 className="card-title p-0">{t("Cancellation")} {t("Policy")}</h2>
                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="skyblue" class="bi bi-exclamation-circle-fill ml-2 mt-1" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                </svg>

              </div>
              <div className="border border-info rounded px-2 py-3 bg-light">
                <h3>{t("Attention")}!</h3>
                <p style={{margin:"0px"}}>{allInformation!==null?allInformation?.cancel_policy?.description.split("\n").map((m,can_i)=>(
                
                    <>
                    {(can_i%2)===1?<br/>:<></>}
                    {m}
                 </>
                )):""}</p>
              </div>
              <span style={{fontSize:"12px"}}><span style={{ color: "red" }}>*</span> {lnstr=="en"? "Time Zone according to your settings is (UTC +0)":"الوقت محلي للموقع بنطاق (UTC +0)"}</span>
            </div>
            <div className="mt-4">
              <h3 style={{ fontSize: "20px" }}>{formatTime(timeLeft)}</h3>
              <span>{t("Pay")} {t("for")} {t("your")} {t("order")} {t("within")} {("15")} {t("minutes")}</span>

              
            </div>
          </div>

</div>
</div>
 </div>
    <Footer />

      {
  isOpen &&
  currentHotelId &&
  roomImage[currentHotelId] &&
  roomImage[currentHotelId].length > 0 &&
  photoIndex < roomImage[currentHotelId].length && (
    <>
      <Lightbox
        mainSrc={roomImage[currentHotelId][photoIndex].url}
        nextSrc={roomImage[currentHotelId][(photoIndex + 1) % roomImage[currentHotelId].length]?.url}
        prevSrc={roomImage[currentHotelId][(photoIndex + roomImage[currentHotelId].length - 1) % roomImage[currentHotelId].length]?.url}
        onCloseRequest={() => setIsOpen(false)}
        onMovePrevRequest={() =>
          setPhotoIndex(
            (photoIndex + roomImage[currentHotelId].length - 1) %
              roomImage[currentHotelId].length
          )
        }
        onMoveNextRequest={() =>
          setPhotoIndex((photoIndex + 1) % roomImage[currentHotelId].length)
        }
        imageTitle={`${photoIndex + 1} / ${roomImage[currentHotelId].length}`}
        wrapperClassName="custom-lightbox"
      />
        <div
                  style={{
                    position: 'fixed',
                    bottom: 10,
                    left: 0,
                    right: 0,
                    padding: '10px 20px',
                    display: 'flex',
                    overflowX: 'auto',
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    zIndex: 1600,
                    gap: '10px',
                  }}
                >
                  {roomImage[currentHotelId]?.map((img, idx) => (
                    <img
                      key={idx}
                      src={img.url}
                      alt={`Thumb ${idx}`}
                      onClick={() => setPhotoIndex(idx)}
                      style={{
                        width: '80px',
                        height: '60px',
                        objectFit: 'cover',
                        border: idx === photoIndex ? '3px solid #00bfff' : '2px solid #666',
                        opacity: idx === photoIndex ? 1 : 0.6,
                        cursor: 'pointer',
                        borderRadius: '4px',
                        transition: 'all 0.2s ease-in-out',
                      }}
                    />
                  ))}
                </div>
    
      {/* thumbnail viewer stays same */}
    </>
  )
}

    {timeExpired && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "10px",
              width:"350px",
              maxWidth: "400px",
              textAlign: "center",
              boxShadow: "0 0 15px rgba(0,0,0,0.3)",
            }}
          >
            <h4>⏰ {t("Current")} {t("session")} {t("is")} {t("over")}.</h4>
            <p>{t("Please")} {t("update")} {t("your")} {t("search")} {t("request")}</p>
            <button onClick={handleRestart} className="btn mt-3">
              {t("Repeat")} {t("the")} {t("search")}
            </button>
          </div>
        </div>
      )}
      {cancellationPolicyBox && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
          className="w-50 w-sm-75"
            style={{
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "5px",
              maxWidth: "500px",
             
              boxShadow: "0 0 15px rgba(0,0,0,0.3)",
            }}
          >
            <h4 style={{textAlign:"start", marginBottom:"10px"}}>{t("Cancellation")} {t("Policy")}</h4>
            <p style={{margin:"0px", marginBottom:"10px"}}>{allInformation!==null?allInformation?.cancel_policy?.description.split("\n").map((m,can_i)=>(
                
                <>
                {(can_i%2)===1?<br/>:<></>}
                {m}
             </>
            )):""}</p>
            <p style={{fontSize:"12px",}}><span style={{ color: "red" }}>*</span>{lnstr=="en"? "Time Zone according to your settings is (UTC +0)":"الوقت محلي للموقع بنطاق (UTC +0)"}</p>
            <button onClick={handleClose} className="btn" style={{width:"70px"}}>
             {t("OK")}
            </button>
          </div>
        </div>
      )}
    {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </Fragment>
  );
};


export default HotelOfferPage;